import { Alert } from 'antd'
import { HTS_TAB_DETAILS } from '@Orders/constants'

import Box from '~/core/Box'
import Link from '~/core/Link'
import styles from '../styles.css'
import { getenv } from '~/settings'

export default function HTSSubheader(props: {
    isAllHtsValuesSubmitted: boolean
    onDownloadCsv: Function
    typeOfHts: string
}) {
    const { isAllHtsValuesSubmitted } = props

    return (
        <Box
            direction="col"
            className={`${styles.htsSectionStyle}
                        ${styles.htsDdpSubSectionWidth}
                    `}
        >
            <Box className={styles.htsSubHeader}>
                2. Please enter HTS code, part description and application
                information below
            </Box>
            {!isAllHtsValuesSubmitted && (
                <Alert
                    type="info"
                    className={styles.alertStyle}
                    message={
                        <span>
                            <b>Tip: </b> For help finding appropriate HTS codes
                            use this{' '}
                            <Link
                                href={`${
                                    getenv('REGIONAL_CONFIGS')?.urls
                                        ?.guide_to_international_shipping_requirements
                                }`}
                                placement={HTS_TAB_DETAILS}
                                target="_blank"
                                name="HTS help article link"
                            >
                                guide.
                            </Link>{' '}
                            To collect this information from someone else,
                            download our HTS code and part description template
                            here.
                        </span>
                    }
                />
            )}
        </Box>
    )
}
